import React from 'react';
import { Star, ArrowRight, Zap, Calendar, Users, Clock } from 'lucide-react';
import { useEventsData } from '../contexts/GlobalDataContext';
import WebinarCard from './WebinarCard';

const navigateToEvents = () => {
  window.history.pushState({}, '', '/events');
  window.dispatchEvent(new PopStateEvent('popstate'));
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const FeaturedEvents = () => {
  const { events, loading } = useEventsData();

  if (loading) return null;

  // Filter: featured=true AND status=published AND future events only
  const featuredList = (events || [])
    .filter(event => 
      event.is_featured === true && 
      event.status === 'published' && 
      new Date(event.event_time) >= (Date.now() - 3600000)
    )
    .sort((a, b) => new Date(a.event_time) - new Date(b.event_time))
    .slice(0, 6);

  if (featuredList.length === 0) return null;

  return (
    <section className="py-14 bg-[#0D1117] border-b border-[#161B22] relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-[#58A6FF]/[0.02] to-transparent pointer-events-none" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#58A6FF]/10 border border-[#58A6FF]/20 text-[#58A6FF] text-[10px] font-bold uppercase tracking-wider mb-3">
              <Star className="w-3.5 h-3.5 fill-current" /> Featured Events
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold text-white tracking-tight">
              Premium Industry Summits & Workshops
            </h2>
            <p className="text-sm text-[#8B949E] mt-1.5 leading-relaxed">
              Curated top-priority engineering events, masterclasses, and conferences.
            </p>
          </div>
          
          <button
            onClick={navigateToEvents}
            className="text-sm font-bold text-[#58A6FF] hover:text-white transition-colors flex items-center gap-1.5 group flex-shrink-0"
          >
            Explore all webinars <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
          </button>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredList.map(event => (
            <WebinarCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedEvents;
